export default __webpack_public_path__ + "src/assets/icn-save-dash-board-settings.59e351eef0e102e0072049c919943c86.svg";